import { render, staticRenderFns } from "./trainingTile.vue?vue&type=template&id=9edff69a"
import script from "./trainingTile.vue?vue&type=script&lang=js"
export * from "./trainingTile.vue?vue&type=script&lang=js"
import style0 from "./trainingTile.vue?vue&type=style&index=0&id=9edff69a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports